import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TreatmentPlanItem } from '@xmedical/core';

// Pure dialog content — returns a treatment-plan item value via
// dialogRef.close(). The opener (treatment-plan-actions-widget) persists
// via TreatmentPlansRepositoryService.
@Component({
  selector: 'xcs-treatment-plan-item-add-card',
  templateUrl: './treatment-plan-item-add-card.component.html',
  styleUrls: ['./treatment-plan-item-add-card.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
  ],
})
export class TreatmentPlanItemAddCardComponent implements OnInit {

  private dialogRef = inject<MatDialogRef<TreatmentPlanItemAddCardComponent>>(MatDialogRef);
  private formBuilder = inject(UntypedFormBuilder);

  validate = false;
  form: UntypedFormGroup | null = null;

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      action: ['', Validators.required],
    });
  }

  save(): void {
    if (!this.form) return;
    if (this.form.valid) {
      this.dialogRef.close(this.form.value as TreatmentPlanItem);
    }
    this.validate = true;
  }

  close(): void {
    this.dialogRef.close();
  }
}
